import { render, staticRenderFns } from "./end-game.vue?vue&type=template&id=b37d1890&"
import script from "./end-game.vue?vue&type=script&lang=js&"
export * from "./end-game.vue?vue&type=script&lang=js&"
import style0 from "./end-game.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports